// extracted by mini-css-extract-plugin
module.exports = {"stats":"Stats_stats__mw-RP","welcome":"Stats_welcome__idkQv"};